export const NOT_AUTHORIZED = "not_authorized";
export const SF_APP = "sfAppState";
export const SF_USER = "userReducer";

export const POPUP_WINDOW_WIDTH = "500";
export const POPUP_WNDOW_HEIGHT = "400";

export const FB = {
  SCOPE: "ads_management"
};

//Version check and page reload related
export const HARD_RELOAD = "hard_reload";
export const EMPTY_DATA_AND_HARD_RELOAD = "empty_data_and_hard_reload";

export const MIXPANEL_REPORT_URL = "https://mixpanel.com/report/";
export const FRESHCHAT_URL = "https://web.freshchat.com/";

export const RESULTS_STATUS_DISPLAY = {
  running: "Running",
  completed: "Completed",
  queued: "Queued",
  failed: "Failed"
};

export const CLIENT_DISPLAY_NAME = {
  spokesly: "Spokesly",
  clearout: "Clearout",
  clearout_phone: "Clearoutphone",
  clearout_eu: "Clearout EU",
  clearout_ep: "Clearout EP"
};

export const COP_ANALYSIS_TABLE_DISPLAY_ORDER = [
  "duplicate",
  "unknown",
  "profile"
];
export const ANALYSIS_TABLE_DISPLAY_ORDER = [
  "duplicate",
  "syntax_error",
  "disposable",
  "free_account",
  "role_account",
  "profile"
];
export const EMAIL_FINDER_ANALYSIS_TABLE_DISPLAY_ORDER = [
  "duplicate",
  "business"
];
export const DELIVERABILITY_TABLE_DISPLAY_ORDER = ["total", "billable"];

export const EMAIL_FINDER_DELIVERABILITY_TABLE_DISPLAY_ORDER = ["total", "billable", "confidence_level"];

export const PIECHART_RESULT_ORDER = [
  "valid",
  "invalid",
  "catch_all",
  "unknown"
];
export const COP_PIECHART_RESULT_ORDER = ["valid", "invalid", "unknown"];
export const SUMMARY_TABLE_ORDER = [
  "valid",
  "invalid",
  "catch_all",
  "unknown",
  "total"
];
export const GRAPH_COLORS = [
  "#c6e377",
  "#f16f6f",
  "#75cac3",
  "#c0c0c0",
  "#970690"
];

export const RESULTS = {
  total: {
    display_name: 'Total',
    type: 'value'
  },
  valid: {
    display_name: 'Valid',
    type: 'percentage'
  },
  invalid: {
    display_name: 'Invalid',
    type: 'percentage'
  },
  catch_all: {
    display_name: 'Catch All',
    type: 'percentage'
  },
  unknown: {
    display_name: 'Unknown',
    type: 'percentage'
  },
  duplicate: {
    display_name: 'Duplicate',
    type: 'percentage'
  },
  disposable: {
    display_name: 'Disposable',
    type: 'percentage'
  },
  role_account: {
    display_name: 'Role Account',
    type: 'percentage'
  },
  free_account: {
    display_name: 'Free Account',
    type: 'percentage'
  },
  profile: {
    display_name: 'Profile Account',
    type: 'percentage'
  },
  billable: {
    display_name: 'Billable',
    type: 'value'
  },
  deliverability_score: {
    display_name: 'Deliverability Score',
    type: 'percentage'
  },
  syntax_error: {
    display_name: 'Syntax Error',
    type: 'percentage'
  },
  found: {
    display_name: "Emails Found",
    type: 'percentage'
  },
  business: {
    display_name: "Business",
    type: "percentage"
  },
  confidence_level: {
    display_name: 'Confidence Level',
    type: 'text'
  }
}

export const COP_RESULTS = {
  total: {
    display_name: 'Total',
    type: 'value'
  },
  billable: {
    display_name: 'Billable',
    type: 'value'
  },
  valid: {
    display_name: "Valid",
    type: "percentage"
  },
  invalid: {
    display_name: "Invalid",
    type: "percentage"
  },
  unknown: {
    display_name: "Unknown",
    type: "percentage"
  },
  duplicate: {
    display_name: "Duplicate",
    type: "percentage"
  }
};

export const PAGINATION_FILTERS = {
  "10": {
    display_name: "10",
    action_value: 10
  },
  "25": {
    display_name: "25",
    action_value: 25
  },
  "50": {
    display_name: "50",
    action_value: 50
  },
  "100": {
    display_name: "100",
    action_value: 100
  }
};

export const STATUS_FILTERS = {
  running: {
    display_name: "Running",
    action_value: "running"
  },
  all: {
    display_name: "All",
    action_value: "all"
  },
  queued: {
    display_name: "Queued",
    action_value: "queued"
  },
  failed: {
    display_name: "Failed",
    action_value: "failed"
  },
  completed: {
    display_name: "Completed",
    action_value: "completed"
  }
};

export const TOP_RESULTS_TABLE_DISPLAY_ORDER = [
  "total",
  "valid",
  "invalid",
  "catch_all",
  "unknown"
];
export const COP_TOP_RESULTS_TABLE_DISPLAY_ORDER = ["valid", "invalid"];
export const TOP_EMAIL_FINDER_RESULTS_TABLE_DISPLAY_ORDER = ["total", "found"];

export const SF_API = {
  Success: "success",
  Failure: "failed",
  Header: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
};

export const CHAT_REMOVED = "removed";
export const CHAT_CLOSED = "closed";

export const PLATFORM = {
  Taboola: "taboola",
  Facebook: "facebook"
};

export const SOCKET_CLIENT = {
  Host: "http://localhost",
  Port: "8080",
  Path: "/sfpush"
};

export const PayloadAction = {
  New: "new",
  Edit: "edit",
  Cancel: "cancel",
  AcceptDelay: "acceptdelay",
  ReachPickupDelay: "reachpickupdelay",
  PickupDelay: "pickupdelay",
  DeliveryDelay: "deliverydelay",
  MessageReceived: "message_receive",
  NewMeeting: "meeting_created",
  UserJoin: "user_join",
  UserLeave: "user_leave",
  UserInvite: "user_invite",
  UserStartTyping: "user_start_typing",
  MeetingJoined: "meeting_joined",
  Invited: "meeting_invited",
  EndMeeting: "meeting_ended",
  NetworkStatusChange: "network_status_change",
  SystemInvitation: "system_invite"
};

export const DATERANGE_PRESETS = {
  date_range_presets: [
    "ps_today",
    "ps_yesterday",
    "ps_this_week_mon_today",
    "ps_last_7_days_including_today",
    "ps_last_week_mon_sun",
    "ps_this_month",
    "ps_last_month",
    "ps_this_year",
    "ps_last_year"
  ],
  date_range_presets_definitions: {
    ps_today: {
      display_name: "Today",
      value: "ps_today"
    },
    ps_yesterday: {
      display_name: "Yesterday",
      value: "ps_yesterday"
    },
    ps_last_7_days_including_today: {
      display_name: "Last 7 days (Including Today)",
      value: "ps_last_7_days_including_today"
    },
    ps_this_week_mon_today: {
      display_name: "This week (Mon - Today)",
      value: "ps_this_week_mon_today"
    },
    ps_last_week_mon_sun: {
      display_name: "Last week (Mon - Sun)",
      value: "ps_last_week_mon_sun"
    },
    ps_this_month: {
      display_name: "This Month",
      value: "ps_this_month"
    },
    ps_last_month: {
      display_name: "Last Month",
      value: "ps_last_month"
    },
    ps_this_year: {
      display_name: "This Year",
      value: "ps_this_year"
    },
    ps_last_year: {
      display_name: "Last Year",
      value: "ps_last_year"
    },
    ps_last_24_hours: {
      display_name: "Last 24 Hrs",
      value: "ps_last_24_hours"
    }
  }
};

export const UserEventsList = {
  logout: {
    display_name: "Logout",
    type: "app",
    action_value: "logout",
    user_ack: 1
  },
  page_reload: {
    display_name: "Reload Page",
    type: "app",
    action_value: "page_reload",
    user_ack: 1
  },
  force_logout: {
    display_name: "Logout (Forcefully)",
    type: "app",
    action_value: "logout",
    user_ack: 0
  },
  force_page_reload: {
    display_name: "Reload Page (Forcefully)",
    type: "app",
    action_value: "page_reload",
    user_ack: 0
  }
};

export const ALL_RESULT_METRICS = [
  "total",
  "valid",
  "invalid",
  "catch_all",
  "unknown",
  "duplicate",
  "syntax_error",
  "disposable",
  "free_account",
  "role_account"
];
export const COP_ALL_RESULT_METRICS = [
  "valid",
  "invalid",
  "unknown",
  "duplicate"
];
export const EMAIL_FINDER_RESULT_METRICS = [
  "total",
  "business",
  "duplicate",
  "found"
]
export const LIST_STATUSES = {
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
}
export const LIST_ACTIONS = {
  sync: {
    value: "sync",
    display: "Sync",
    progress: "Syncing",
    queued: " Queued",
    history: "synced"
  },
  verify: {
    value: "verify",
    display: "Verify",
    progress: "Verifying",
    queued: " Queued",
    history: "verified"
  },
  pnv: {
    value: "pnv",
    display: "PNV",
    progress: "Verifying",
    queued: " Queued",
    history: "verified"
  },
  analyse: {
    value: "analyse",
    display: "Analyse",
    progress: "Analyzing",
    queued: " Queued",
    history: "analysed"
  },
  export: {
    value: "export",
    display: "Export",
    progress: "Exporting",
    queued: " Queued",
    history: "exported"
  },
  failed: {
    value: "failed",
    display: "Failed",
    progress: "Failing",
    queued: " Queued",
    history: "failed"
  },
  find_emails: {
    value: 'email_finder',
    display: 'Finding Emails',
    progress: 'Finding Emails',
    queued: ' Queued',
    history: 'Email Found'
  },
  enrich: {
    progress: 'Enriching !!!'
  }
};
export const LIST_TYPES = {
  mailchimp: {
    value: "mailchimp",
    label: "Mailchimp"
  },
  apollo: {
    value: "apollo",
    label: "Apollo"
  },
  active_campaign: {
    value: "active_campaign",
    label: "ActiveCampaign"
  },
  moosend: {
    value: "moosend",
    label: "Moosend"
  },
  mailerlite: {
    value: "mailerlite",
    label: "MailerLite"
  },
  sendgrid: {
    value: "sendgrid",
    label: "Sendgrid"
  },
  automizy: {
    value: "automizy",
    label: "Automizy"
  },
  clevertap: {
    value: "clevertap",
    label: "CleverTap"
  },
  hubspot: {
    value: "hubspot",
    label: "Hubspot"
  },
  lemlist: {
    value: "lemlist",
    label: "Lemlist"
  },
  upload: {
    value: "upload",
    label: "Upload"
  },
  leads: {
    value: "leads",
    label: "Leads"
  },
  all: {
    label: "All",
    value: "all"
  }
};
export const VERIFIED_TYPES = {
  verified: {
    value: "verified",
    label: "Verified"
  },
  non_verified: {
    value: "non_verified",
    label: "Non-Verified"
  },
  in_progress: {
    value: "in_progress",
    label: "In Progress"
  },
  cancelled: {
    value: "cancelled",
    label: "Cancelled"
  }
};
export const FINDER_TYPES = {
  processed: {
    value: "processed",
    label: "Completed"
  },
  non_processed: {
    value: "non_processed",
    label: "Not-Processed"
  },
  in_progress: {
    value: "in_progress",
    label: "In Progress"
  },
  cancelled: {
    value: "cancelled",
    label: "Cancelled"
  }
}
export const DOWNLOAD_FILE_APPEND_COLUMNS = [
  "status",
  "reason",
  "score",
  "suggested_email_address",
  "greylist_count",
  "disposable",
  "free_account",
  "role_account",
  "account",
  "domain",
  "verified_on",
  "time_taken"
];

export const COP_DOWNLOAD_FILE_APPEND_COLUMNS = ['status', 'carrier', 'country_code', 'country_name', 'country_timezone', 'e164_format', 'international_format', 'line_type', 'local_format', 'location', 'verified_on', 'time_taken']

// export const DOWNLOAD_VALIDATION_FILTER =['valid','invalid','unknown']
export const APPEND_HELP_TEXT =
  "All columns selected for append will be appended with 'CO' in result file. Eg: Status will be 'CO Status'.";
export const UNSUBSCRIBE_HELP_TEXT =
  "Selecting Unsubscribe as part of export will unsubscribe those contacts in the mailchimp list whose email address matches with the selected validated result status option email address";
export const DOWNLOAD_VALIDATION_FILTER = [
  "valid",
  "invalid",
  "catch_all",
  "unknown"
];
export const COP_DOWNLOAD_VALIDATION_FILTER = ["valid", "invalid", "unknown"];
// export const STATUS_FILTER_HELP_TEXT="By applying status filter will generate the result file with the email addresses that match the chosen status values "
export const STATUS_FILTER_HELP_TEXT =
  "Apply this filter to include verified email addresses with a particular status from - Valid, Invalid, Unknown and Catch all.";

export const VALIDATION_FILTERS = {
  valid: {
    value: "valid",
    name: "Valid"
  },
  invalid: {
    value: "invalid",
    name: "Invalid"
  },
  catch_all: {
    value: "catch_all",
    name: "Catch All"
  },
  unknown: {
    value: "unknown",
    name: "Unknown"
  }
};

export const APPEND_COLUMNS = {
  status: {
    value: "status",
    name: "Status"
  },
  reason: {
    value: "reason",
    name: "Reason"
  },
  score: {
    value: "score",
    name: "Score"
  },
  greylist_count: {
    value: "greylist_count",
    name: "Greylist Count"
  },
  verified_on: {
    value: "verified_on",
    name: "Verified On"
  },
  suggested_email_address: {
    value: "suggested_email_address",
    name: "Suggested Email Address"
  },
  disposable: {
    value: "disposable",
    name: "Disposable"
  },
  role_account: {
    value: "role_account",
    name: "Role Account"
  },
  free_account: {
    value: "free_account",
    name: "Free Account"
  },
  account: {
    value: "account",
    name: "Account"
  },
  domain: {
    value: "domain",
    name: "Domain"
  },
  time_taken: {
    value: "time_taken",
    name: "Time Taken"
  }
};

export const INTEGRATION_PLATFORMS = [
  "mailchimp",
  "active_campaign",
  "moosend",
  "hubspot"
];

export const MATOMO_URL = "https://analytics.clearout.io";

export const COUPON_STATUS = {
  active: {
    display: "Active",
    value: "active"
  },
  inactive: {
    display: "Inactive",
    value: "inactive"
  },
  revoked: {
    display: "Revoked",
    value: "revoked"
  }
};

export const COUPON_TYPE = {
  standard: {
    display: "Standard",
    value: "standard"
  },
  discount: {
    display: "Discount",
    value: "discount"
  },
  bonus: {
    display: "Bonus",
    value: "bonus"
  }
};

export const COUPON_MIN_VALUE_CREDITS = 5000;
export const COUPON_MAX_VALUE_CREDITS = 10000;
export const COUPON_CREDITS_DEFAULT_VALUE = 100000;
export const COUPON_MAX_VALUE_FIXED = 10000;
export const COUPON_REDEEM_COUNT = 100000;
export const COUPON_MIN_FOR_FIXED = 21;
export const COUPON_SLAB_UNIT_PRICE = 0.001;
export const COUPON_SLAB_MAX_UNIT_PRICE = 0.005;
export const COUPON_DISCOUNT_FIXED_DEFAULT = 10;
export const COUPON_MAX_LENGTH = 15;
export const COUPON_MIN_LENGTH = 4;

export const COUPON_CONSTANTS = {
  NAME: "Coupon name",
  COUPON_ID: "Coupon id will used by customers for applying discount",
  REDEEM_COUNT: "Number of times the customer can redeem the coupon",
  COUPON_TYPE: "Coupon type : standard or discount or bonus coupon",
  DISCOUNT_TYPE: "Select discount type",
  SLAB_MIN: "Minimum credits to be purchased by user for applying the coupon",
  SLAB_MAX: "Maximum credits to be purchased by user for applying the coupon",
  SLAB_VAL: "Unit price for each credit",
  FIXED_MIN: "Minimum billing amount for coupon to be applied",
  FIXED_MAX: "Maximum billing amount for coupon to be applied",
  FIXED_VAL: "Flat value which will be subtracted from the billing price",
  PERC_MIN: "Minimum billing amount for the coupon to be applied",
  PERC_MAX: "Maximum billing amount for the coupon to be applied",
  PERC_VAL: "Percentage of amount to be decreased from billing price",
  CREDITS: "Credits for assigning the user",
  USER_EMAIL: "Select the user for this coupon",
  AFFILIATE: "Enter the affiliate name",
  DAILY_VERIFY_LIMIT: "Enter the daily limit for verification"
};

export const CLIENT_SECRET =
  "5b98682fe6339bf7706a3bf335b1568089d8a507c9a6a95ef60a3739b862a961";

export const DELIVERABLES =
  "The result file will include only the valid email addresses appended to your original list. Sending emails to these email addresses are completely safe.";
export const DELIVERABLES_GUARANTEED =
  "The result will only include the email addresses that are guaranteed to be delivered to the mailbox of the recipient, i.e. no bounce back. Sending emails to these email addresses is completely safe as long as the email is sent anytime before 24 hours from the verified time. The downloaded result will also contain Clearout standard columns appended to the original columns.";

export const NON_DELIVERABLES =
  "The result file will include only the invalid email addresses appended to your original list. An email address will be marked 'invalid' for many reasons. Avoid sending emails to these email addresses.";
export const NON_DELIVERABLES_SAFE_TO_SEND =
  "The result will include the email addresses that will certainly bounce, so it is highly recommended not to send any emails to such addresses and unsubscribe them from the mailing list";

export const DELIVERABLES_WITH_RISK =
  "The result file will include email addresses that are guaranteed to be delivered along with the email addresses that are determined as risky. The email address of this result file are safe to be used when bounce rate is strictly below 5% or running dedicated mail server with out dependence on external Email Service Provider(ESP).";

export const VALID_PHONE_NUMBER =
  "The resulting file will include only the valid phone numbers appended to your original list. These numbers are syntax free and reachable.";

export const INVALID_PHONE_NUMBER =
  "The resulting file will include only the Invalid phone numbers appended to your original list. These numbers won't be reachable and can be safely removed from the list.";

export const DOWNLOAD_ORIGINAL_FILE_OPTION =
  "Original file with clearout standard columns";
export const DOWNLOAD_ORIGINAL_FILE_OPTION_WITH_DUPLICATE =
  "Original file with clearout standard columns (include duplicates)";
export const SUBSCRIPTION_FILTERS = {
  status: [
    {
      value: 'active',
      label: 'Active'
    },
    {
      value: 'cancelled',
      label: 'Cancelled'
    }
  ],
  planType: [
    {
      value: 'yearly',
      label: 'Annually'
    },
    {
      value: 'monthly',
      label: 'Monthly'
    }
  ],
  userType: [
    {
      value: 'none',
      label: 'All'
    },
    {
      value: 'subscriber',
      label: 'Subscribed'
    },
    {
      value: 'paid',
      label: 'Paid'
    }
  ],
  userStatusType: [
    {
      value: 'none',
      label: 'All'
    },
    {
      value: 'active',
      label: 'Active'
    },
    {
      value: 'inactive',
      label: 'InActive'
    },
  ],
  orgUserStatusType: [
    {
      value: 'all',
      label: 'All'
    },
    {
      value: 'active',
      label: 'Active'
    },
    {
      value: 'inactive',
      label: 'InActive'
    },
    {
      value: 'new',
      label: 'Yet to Activate'
    },
    {
      value: 'removed',
      label: 'Removed'
    }
  ],
  role: [
    {
      value: 'none',
      label: 'All'
    },
    {
      value: 'owner',
      label: 'Owner'
    },
    {
      value: 'admin',
      label: 'Manager'
    },
    {
      value: 'analyst',
      label: 'Executive'
    },
  ]
}
export const EMAIL_VERIFY_MODES = {
  'highest_accuracy': 'Highest Accuracy',
  'fastest_turnaround': 'Fastest Turnaround',
}

export const API_SERVICES_OPTIONS =
  [
    { label: 'Instant Email Verify', value: 'instant_email_verify_limit', },
    { label: 'Instant Email Finder', value: 'instant_email_finder_limit' },
    { label: 'All API\'s', value: 'all_service' }
  ]

export const API_RATELIMIT_SERVICES = {
  INSTANT_EMAIL_VERIFY_LIMIT: 'instant_email_verify_limit',
  INSTANT_EMAIL_FINDER_LIMIT: 'instant_email_finder_limit',
}

export const OWNER_RESTRICT_ROLES = ['owner'];

export const USER_ROLES = {
  "admin": {
    value: 'admin',
    label: 'Manager'
  },
  'analyst': {
    value: 'analyst',
    label: 'Executive'
  },
};

export const RANGES_LIMIT = {
  "daily": {
    value: 'daily',
    label: 'Daily'
  },
  'life_time': {
    value: 'life_time',
    label: 'Lifetime'
  }
};

export const COP_API_SERVICES_OPTIONS =
  [
    { label: 'Instant Phone Number Validator', value: 'instant_phonenumber_validate_limit', },
    { label: 'All API\'s', value: 'all_service' }
  ]

export const COP_API_RATELIMIT_SERVICES = {
  INSTANT_PHONENUMBER_VALIDATE_LIMIT: 'instant_phonenumber_validate_limit',
}

export const SYSTEM_ACTIVITIES = {
  tasks: {
    none: {
      value: 'none',
      label: 'All',
      filterLabel: 'Action'
    },
    signup_abuse: {
      value: 'signup_abuse',
      label: 'Signup Abuse',
      filterLabel: 'Action'
    },
    signup_activation_abuse: {
      value: 'signup_activation_abuse',
      label: 'Signup Activation Abuse',
      filterLabel: 'Action'
    },
    abuse_limiter_updated: {
      value: 'abuse_limiter_updated',
      label: 'Abuse Limiter Updates',
      filterLabel: 'Action'
    },
    abuse_list_updated: {
      value: 'abuse_list_updated',
      label: 'Abuse List Updates',
      filterLabel: 'Action'
    },
    email_edit_abuse: {
      value: 'email_edit_abuse',
      label: 'Email Edit Abuse',
      filterLabel: 'Action'
    },
  },
  names: {
    none: {
      value: 'none',
      label: 'All',
      filterLabel: 'Type'
    },
    ip_blocked: {
      value: 'ip_blocked',
      label: 'IP Blocked',
      filterLabel: 'Type'
    },
    ip_unblocked: {
      value: 'ip_unblocked',
      label: 'IP Unblocked',
      filterLabel: 'Type'
    },
    domain_blocked: {
      value: 'domain_blocked',
      label: 'Domain Blocked',
      filterLabel: 'Type'
    },
    domain_unblocked: {
      value: 'domain_unblocked',
      label: 'Domain Unblocked',
      filterLabel: 'Type'
    },
    email_whitelisted: {
      value: 'email_whitelisted',
      label: 'Email Whitelisted',
      filterLabel: 'Type'
    },
    email_delisted: {
      value: 'email_delisted',
      label: 'Email Delisted',
      filterLabel: 'Type'
    },
    email_denied: {
      value: 'email_denied',
      label: 'Email Denied',
      filterLabel: 'Type'
    },
    matomo_blocked: {
      value: 'matomo_blocked',
      label: 'Matomo Blocked',
      filterLabel: 'Type'
    },
    country_blocked: {
      value: 'country_blocked',
      label: 'Country Blocked',
      filterLabel: 'Type'
    },
    country_unblocked: {
      value: 'country_unblocked',
      label: 'Country Unblocked',
      filterLabel: 'Type'
    }
  }
}

export const PROSPECT_LIST_STATUS = {
  enriched: {
    value: "enriched",
    label: "Enriched"
  },
  non_enriched: {
    value: "non_enriched",
    label: "Not-Enriched"
  },
  in_progress: {
    value: "in_progress",
    label: "In Progress"
  },
  cancelled: {
    value: "cancelled",
    label: "Cancelled"
  }
}

export const PROSPECT_LIST_TYPES = {
  person: {
    value: 'person',
    label: 'Person'
  },
  company: {
    value: 'company',
    label: 'Company'
  },
  all: {
    value: 'all',
    label: 'All'
  }
}

export const ACCOUNT_DELETE_REASONS = {
  'data_privacy_concern': 'Data Privacy Concern',
  'alternative_found': 'Alternative Found',
  'temporary_suspension_required': 'Temporary Suspension Required',
  'service_no_longer_needed': 'Service No Longer Needed',
  'none_of_the_above': 'None of the Above'
}

export const COUPON_DEFAULT_VALUES = {
  discount: {
    slab: {
      minText: "Minimum Credits",
      maxText: "Maximum Credits",
      discountValText: "Unit Price",
      tooltip: COUPON_CONSTANTS.SLAB_VAL,
      minTooltip: COUPON_CONSTANTS.SLAB_MIN,
      maxTooltip: COUPON_CONSTANTS.SLAB_MAX,
      discountVal: COUPON_SLAB_UNIT_PRICE,
      minVal: COUPON_MIN_VALUE_CREDITS,
      maxVal: COUPON_CREDITS_DEFAULT_VALUE,
    },
    fixed: {
      minText: "Minimum Amt",
      maxText: "Maximum Amt",
      discountValText: "Discount Amt",
      tooltip: COUPON_CONSTANTS.FIXED_VAL,
      minTooltip: COUPON_CONSTANTS.FIXED_MIN,
      maxTooltip: COUPON_CONSTANTS.FIXED_MAX,
      minVal: COUPON_MIN_FOR_FIXED,
      maxVal: COUPON_MAX_VALUE_FIXED,
      discountVal: COUPON_DISCOUNT_FIXED_DEFAULT,
    },
    percentage: {
      minText: "Minimum Amt",
      maxText: "Maximum Amt",
      discountValText: "Discount Percentage",
      tooltip: COUPON_CONSTANTS.PERC_VAL,
      minTooltip: COUPON_CONSTANTS.PERC_MIN,
      maxTooltip: COUPON_CONSTANTS.PERC_MAX,
      minVal: COUPON_MIN_FOR_FIXED,
      maxVal: COUPON_MAX_VALUE_FIXED,
      discountVal: COUPON_DISCOUNT_FIXED_DEFAULT,
    }
  },
  bonus: {
    duration: {
      minText: "Minimum Credits",
      maxText: "Maximum Credits",
      durationText: "Duration In Month",
      minTooltip: "Minimum credits to be purchased by user for applying the coupon",
      maxTooltip: "Maximum credits to be purchased by user for applying the coupon",
      durationTooltip: "Number of months credits to be assigned to the user",
      minVal: 3000,
      maxVal: 5000000,
      durationVal: 1,
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/constants.js